window.Vue = require('vue');
window.axios = require('axios');
window.lodash = require('lodash');
window.blazy = require('blazy');


import vmodal from 'vue-js-modal'
Vue.use(vmodal);

import { Hooper, Slide } from 'hooper';
import 'hooper/dist/hooper.css';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.filter('stripHTML', function (value) {
    const div = document.createElement('div')
    div.innerHTML = value
    return div.textContent || div.innerText || '';
});

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAazgjm_iXi4aoUmc_W65fJQE2kyps--PE', // @todo load from module
        libraries: 'places',
        region: 'NL',
        language: 'nl'
    }
});

Vue.component('hooper', Hooper);
Vue.component('hooper-slide', Slide);

import InstantSearch from 'vue-instantsearch';
Vue.use(InstantSearch);

import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

Vue.component('ef2-teaser-slider', require('../vue/components/TeaserSlider').default);
Vue.component('ef2-near-to-slider', require('../vue/components/NeartoSlider').default);
Vue.component('ef2-image-slider', require('../vue/components/ImageSlider').default);
Vue.component('ef2-slider-navigation', require('../vue/components/SliderNavigation').default);
Vue.component('ef2-headroom-wrapper', require('../vue/components/HeadroomWrapper').default);
Vue.component('ef2-mega-menu', require('../vue/components/MegaMenu').default);
Vue.component('ef2-modal-wrapper', require('../vue/components/ModalWrapper').default);
Vue.component('ef2-where-am-i', require('../vue/components/WhereAmI').default);
Vue.component('ef2-qrcode', require('../vue/components/QrCodeWrapper').default);
Vue.component('ef2-calendar-filter', require('../vue/components/CalendarFilter').default);
Vue.component('ef2-survey', require('../vue/components/Survey').default);
Vue.component('ef2-survey-wrapper', require('../vue/components/Surveys/SurveyWrapper.vue').default);
Vue.component('ef2-postal-code-survey', require('../vue/components/Surveys/PostalCodeSurvey.vue').default);
Vue.component('ef2-drupal-view-filters-wrapper', require('../vue/components/DrupalViewFiltersWrapper').default);
Vue.component('ef2-drupal-view-filter-dropdown', require('../vue/components/DrupalViewFilterDropdown').default);
Vue.component('ef2-accordion', require('../vue/components/Accordion').default);
Vue.component('ef2-favorite-button', require('../vue/components/FavoriteButton').default);
Vue.component('ef2-favorites-list', require('../vue/components/FavoritesList').default);

// Shapes
Vue.component('ef2-brand-shape-line', require('../vue/components/shapes/ShapeBrandLine').default);
Vue.component('ef2-brand-shape-line-dotted', require('../vue/components/shapes/ShapeBrandLineDotted.vue').default);
Vue.component('ef2-brand-shape', require('../vue/components/shapes/ShapeBrand').default);
Vue.component('ef2-teaser-shape', require('../vue/components/shapes/ShapeTeaser').default);

//Algolia Search
Vue.component('ef2-algolia-search-container', require('../vue/components/algolia/AlgoliaSearchContainer').default);
Vue.component('ef2-algolia-nav-search', require('../vue/components/algolia/AlgoliaNavSearch').default);

Vue.component('search-block', require('../vue/components/SearchBlock').default);
Vue.component('advanced-search-container', require('../vue/components/AdvancedSearchContainer').default);

Vue.component('ef2-distance-block', require('../vue/components/DistanceBlock').default);
Vue.component('ef2-client-location', require('../vue/components/ClientLocation').default);
Vue.component('ef2-insta-slider', require('../vue/components/InstaSlider').default);
Vue.component('ef2-contrast-switch', require('../vue/components/HighContrastSwitch').default);

window.vueBase = new Vue({
    'el': '#page-wrapper',

    comments: true,

    data() {
        return {
            eventBus: new Vue()
        }
    }
});
